var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.toggleDarkMode()}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.darkMode ? "mdi-weather-sunny" : "mdi-weather-night")+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }